import InvoiceAchEntry from "@auer-steel/CustomComponents/PayInvoice/InvoiceAchEntry";
import { PayInvoicePageContext } from "@auer-steel/Pages/PayInvoicePage";
import { AuerState } from "@auer-steel/Store/AuerState";
import updateInvoicePayments from "@auer-steel/Store/Pages/PayInvoice/Handlers/UpdateInvoicePayments";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {
    error: string | boolean,
}

const mapStateToProps = (state: AuerState) => ({
    invoicePaymentCollection: state.payInvoice.invoicePaymentCollection,
});

const mapDispatchToProps = {
    updateInvoicePayments,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const PaymentMethodInformation: React.FunctionComponent<Props> = (props: Props) => {
    if (props.invoicePaymentCollection.invoicePayments.length < 1) {
        return null;
    }

    return (
        <StyledWrapper>
            <InvoiceAchEntry error={props.error} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PaymentMethodInformation),
    definition: {
        group: "Pay Invoice" as any,
        allowedContexts: [PayInvoicePageContext],
    },
};

export default widgetModule;
